/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Presence_OkInputs */

const en_tut_presence_ok = /** @type {(inputs: Tut_Presence_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The dot and label on your row change immediately, and colleagues see your local time without doing timezone arithmetic.`)
};

const id_tut_presence_ok = /** @type {(inputs: Tut_Presence_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warna titik dan label di baris Anda berubah seketika, dan rekan melihat jam setempat Anda tanpa harus menghitung selisih zona waktu.`)
};

/**
* | output |
* | --- |
* | "The dot and label on your row change immediately, and colleagues see your local time without doing timezone arithmetic." |
*
* @param {Tut_Presence_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_presence_ok = /** @type {((inputs?: Tut_Presence_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Presence_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_presence_ok(inputs)
	return en_tut_presence_ok(inputs)
});